var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Scroll } from '@shared/Scroll';
import React from 'react';
var DEFAULT_STYLE = {
    margin: 0,
    padding: 0,
    display: 'grid',
    maxWidth: '100%',
    position: 'relative',
};
var DEFAULT_HEADER_STYLE = {
    position: 'sticky',
    left: 0,
    right: 0,
    top: 0,
};
var DEFAULT_FOOTER_STYLE = {
    position: 'sticky',
    left: 0,
    right: 0,
    bottom: 0,
};
function List(_a) {
    var items = _a.items, renderItem = _a.renderItem, style = _a.style, Footer = _a.Footer, Header = _a.Header, _b = _a.gap, gap = _b === void 0 ? 0 : _b, _c = _a.numColumns, numColumns = _c === void 0 ? 1 : _c, _d = _a.innerRef, innerRef = _d === void 0 ? null : _d, props = __rest(_a, ["items", "renderItem", "style", "Footer", "Header", "gap", "numColumns", "innerRef"]);
    var listItems = items.map(renderItem);
    var gridColsProp = "repeat(".concat(numColumns, ", 1fr)");
    var mergedStyle = __assign(__assign(__assign({}, DEFAULT_STYLE), style), { gridTemplateColumns: gridColsProp, gap: gap });
    var maxHeight = mergedStyle.maxHeight;
    var flexGrow = mergedStyle.flexGrow;
    delete mergedStyle.maxHeight;
    delete mergedStyle.flexGrow;
    return (React.createElement(Scroll, { style: { maxHeight: maxHeight, flexGrow: flexGrow } },
        React.createElement("div", __assign({}, props, { ref: innerRef, style: mergedStyle }),
            typeof Header === 'function' ? React.createElement(Header, { style: DEFAULT_HEADER_STYLE }) : Header,
            listItems,
            typeof Footer === 'function' ? React.createElement(Footer, { style: DEFAULT_FOOTER_STYLE }) : Footer)));
}
export default List;
